/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

import React, { Component } from 'react'
import { Route, withRouter} from 'react-router-dom';
import { AppStyles } from './AppStyles';
import {MainMenu, SideMenu, SideMenuItem} from 'yospace-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBriefcase,
    faFilm,
    faHouse,
    faLayerGroup,
    faNetworkWired,
    faPlay,
    faTv
} from '@fortawesome/free-solid-svg-icons';

import ManageAssetPoolsPage from '../manageassetpoolspage/ManageAssetPoolsPage';
import LivePage from '../liveviewpage/LivePage';
import { CookiesProvider, withCookies } from 'react-cookie';
import UserService from "../common/UserService";

import { version } from '../../package.json';
import ActiveEncoderStatusView from "../liveviewpage/ActiveEncoderStatusView";

const PATHS = Object.freeze({
    home: "/home",
    live: "/live",
    vod: "/vod",
    assets: "/assets",
    adIntegration: "/ad-integration",
    adMediator: "/ad-mediator",
    account: "/account"
});

const SIDE_MENU_ITEMS = Object.freeze([
    new SideMenuItem('HOME', React.createElement(FontAwesomeIcon, { icon: faHouse } ), PATHS.home),
    new SideMenuItem('LIVE', React.createElement(FontAwesomeIcon, { icon: faTv } ), PATHS.live),
    new SideMenuItem('VOD', React.createElement(FontAwesomeIcon, { icon: faPlay } ), PATHS.vod),
    new SideMenuItem('ASSETS', React.createElement(FontAwesomeIcon, { icon: faFilm } ), PATHS.assets),
    new SideMenuItem('AD INTEGRATION', React.createElement(FontAwesomeIcon, { icon: faLayerGroup } ), PATHS.adIntegration),
    new SideMenuItem('AD MEDIATOR', React.createElement(FontAwesomeIcon, { icon: faNetworkWired } ), PATHS.adMediator),
    new SideMenuItem('ACCOUNT', React.createElement(FontAwesomeIcon, { icon: faBriefcase } ), PATHS.account)
]);

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedSideMenuItem: SIDE_MENU_ITEMS[0],
        }

        this.handleSideMenuSelect = this.handleSideMenuSelect.bind(this);
    }

    componentDidMount() {
        for (let menuItem of SIDE_MENU_ITEMS) {
            if (menuItem.path === this.props.location.pathname) {
                this.setState({ selectedSideMenuItem: menuItem } );
            }
        }
    }

    handleErrorConfirm() {
        window.location.reload();
    }

    handleLogout() {
        UserService.doLogout();
    }

    handleSideMenuSelect(item) {
        this.setState( { selectedSideMenuItem: item } );
    }

    render() {
        return (
            <CookiesProvider>
                {
                    <div style={AppStyles.getMain()}>
                        <MainMenu title="CUSTOMER MANAGEMENT CONSOLE" version={version} user={UserService.getEmail()}
                                  account={UserService.getUsername()} handleLogout={this.handleLogout} >
                            {
                                window.location.href.indexOf("live") > 0 &&
                                    <ActiveEncoderStatusView />
                            }
                        </MainMenu>

                        <div style={AppStyles.getContainer()}>
                            <div style={AppStyles.getElementContainer()}>
                                <SideMenu
                                    handleSelect={this.handleSideMenuSelect}
                                    menuItems={SIDE_MENU_ITEMS}
                                    selectedItem={this.state.selectedSideMenuItem}
                                />
                            </div>
                            <div style={AppStyles.getSelectedContainer()}>
                                <Route path={PATHS.live} render={() => <LivePage/>}/>
                                <Route path={PATHS.assets} render={() => <ManageAssetPoolsPage/>}/>
                            </div>
                        </div>
                    </div>
                }
            </CookiesProvider>
        )
    }
}

App.propTypes = {
    // None
}

export default withRouter(withCookies(App));
